module.exports = __webpack_public_path__ + "static/media/archived-posts.b396d411.svg";